"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    caption2ClassNames: function() {
        return caption2ClassNames;
    },
    useCaption2Styles: function() {
        return useCaption2Styles;
    }
});
const _react = require("@griffel/react");
const caption2ClassNames = {
    root: 'fui-Caption2'
};
const useCaption2Styles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "f13mqy1h",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fcpl73t"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".f13mqy1h{font-size:var(--fontSizeBase100);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".fcpl73t{line-height:var(--lineHeightBase100);}"
    ]
});
